<template>
  <!-- <div role="region" aria-labelledby="HeadersCol" tabindex="0" class="rowheaders content"> -->
    <!-- <div class="table"> -->
  <div class=content>
    <table>
      <thead>
        <tr>
          <th
            v-for="(value, key) in columns"
            :key="key"
            @click="sortBy(value)"
            :class="[{ active: sortKey == value }]"
          >
            <span v-if="sortKey == value" class="arrow" :class=sortDir></span>
            {{ value | capitalize }}
          </th>
        </tr>
      </thead>
      <tfoot>
        <tr>
          <td colspan="8" v-html=footer></td>
        </tr>
      </tfoot>
      <tbody>
        <tr v-for="(dvalue, dkey) in this.sortedData" :key="dkey">
          <td v-for="(cvalue, ckey) in columns" :key="ckey">{{ dvalue[cvalue] | formatIt }}</td>
          <td v-if="hasDetail"><button type="button" class="btn btn-warning btn-sm" @click="showModal(dvalue)"
            >Details..</button></td>
        </tr>
      </tbody>
    </table>
      <cmodal
        :gdata="this.statedtl" :columns="this.mgcolumns" :footer="this.mgfooter" :mhead="this.state"
        v-show="modalVisible"
        @close="closeModal"
        v-if="this.statedtl.length > 0"
      />
  </div>
</template>

<script>
import wsm from "../../mixin/mixin";
import Cmodal from "./Modal.vue";

function formatIt(gvalue) {
  const formatter = new Intl.NumberFormat("en-IN", {
    /*   style: 'currency', currency: 'USD', */
    minimumFractionDigits: 0
  });
  // console.log("value:", gvalue, "type:", typeof gvalue, "type1:", Number.isNan(gvalue));
  // if (typeof gvalue !== "number") {
  // if (Number.isNaN(gvalue)) return gvalue;
  return formatter.format(gvalue) === "NaN" ? gvalue : formatter.format(gvalue);
}

function capitalize(value) {
  const str = value.toString();
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export default {
  name: 'rgrid',
  props: {
    gdata: Array,
    columns: Array,
    footer: String,
    hasDetail: Boolean
  },
  data() {
    return {
      searchQuery: "",
      sortKey: "Category",
      sortOrders: {},
      gridColumns: [],
      sortDir: "desc",
      currentSort: "name",
      modalVisible: false,
      isLoading: false,
      imagesize: { height: "37%", width: "31%" },
      state: "",
      statedtl: {},
      mgdata: [],
      mgcolumns: [],
      mgfooter: "Let's keep the fight, together we shall conquer Covid19🦠😷.... <a href='https://www.thebetterindia.com/228213/andhra-student-paintings-street-art-must-see-viral-coronavirus-information-education-pictures-gop94/' target='_blank' rel='external'>Check this!</a>.",
    };
  },
  filters: { capitalize, formatIt },
  components: { Cmodal },
  mixins: [wsm],
  methods: {
    showModal(drow) {
      this.modalVisible = true;
      this.getGridDtl(drow);
      this.$emit("fromgrid");
    },
    closeModal() {
      this.isLoading = false;
      this.modalVisible = false;
    },
    sortBy(key) {
      if (key === this.sortKey) {
        this.sortDir = this.sortDir === "asc" ? "desc" : "asc";
      } else {
        this.sortDir = "desc";
      }
      this.sortKey = key;
    },
    compareValues(key, order = "asc") {
      return function innerSort(a, b) {
        if (!Object.prototype.hasOwnProperty.call(a, key) || !Object.prototype.hasOwnProperty.call(b, key)) {
          // property doesn't exist on either object
          return 0;
        }
        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA === null) {
          comparison = 1;
        } else if (varB === null) {
          comparison = 1;
        } else if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        } else {
          comparison = 0;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    },

    setColumns(gc) {
      let gd;
      if (gc === "" || gc === [] || gc.length < 1) {
        gd = this.$root.log1(this.gdata);
        gd = Object.keys(gd[0]);
      } else {
        gd = gc;
      }
      return gd;
    },
    setGrid() {
      this.gridColumns = this.setColumns(this.columns);
      return this.gridColumns;
    },
  },
  computed: {
    sortedData() {
      return this.gdata.sort(this.compareValues(this.sortKey, this.sortDir)); // eslint-disable-line
    }
  },
  created() {}
};
</script>

<style scoped lang="scss">
  @import "../../scss/csstable";
  /* @import "../../scss/rtable"; */
</style>
